import { Badge, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { Event } from 'services/@types';
import { getTopEventsByGuests, formatLastSeen } from './analyticsUtils';
import { useNavigate } from 'react-router-dom';

interface Props {
  events: Event[];
}

export default function TopEventsCard({ events }: Props) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const navigate = useNavigate();
  const top = getTopEventsByGuests(events, 10);

  return (
    <Card p="20px" flex="1" minW="300px">
      <Text color={textColor} fontSize="lg" fontWeight="700" mb="16px">
        Most Active Events
      </Text>
      {top.length === 0 && (
        <Text color="gray.400" fontSize="sm">No data</Text>
      )}
      {top.map((e, i) => (
        <Flex
          key={e.id || i}
          justify="space-between"
          align="center"
          py="8px"
          borderBottom="1px solid"
          borderColor="gray.100"
          cursor="pointer"
          _hover={{ bg: 'gray.50' }}
          onClick={() => e.id && navigate(`/admin/events/detail/${e.id}`)}
        >
          <Flex direction="column">
            <Text color={textColor} fontSize="sm" fontWeight="600">
              {e.name || '-'}
            </Text>
            <Text color="gray.400" fontSize="xs">
              {formatLastSeen(e.dateAndTime as string)}
            </Text>
          </Flex>
          <Badge colorScheme="orange" fontSize="xs">
            {e.numberOfGuests ?? 0} guests
          </Badge>
        </Flex>
      ))}
    </Card>
  );
}
